import { graphql } from 'react-relay';
import { fetchQueryWrapper } from '../helper/graphql';
const CareOrderListQuery = graphql `
  query graphqlClientCareOrderListQuery($_id: String!, $stateList: [Int], $limit: Int) {
    clientCareOrderList(_id: $_id, stateList: $stateList, limit: $limit) {
      _id
      initialType
      state
      certificateId
      isDefaultAsap
      startTime
      endTime

      gender
      age
      height
      weight

      requiredGender

      hospitalBed
      servedItem
      symptom
      tube
      lang
      notes
      contactName
      contactGender
      contactPhone
      contactEmail

      totalPaidFee
      doPayOffPayment
      hourlyServiceFee

      notesParsed
      c_atParsed

      defaultTimeSlotList {
        _id
        state
        platformFeePercentage
        dailyFee
        expectedTotalFee
        expectedStartTime
        expectedEndTime
        expectedServiceHours
        expectedServiceDays
      }
      timeSlotList {
        _id
        state
        platformFeePercentage
        dailyFee
        expectedTotalFee
        expectedStartTime
        expectedEndTime
        expectedServiceHours
        expectedServiceDays
        totalServiceFee
        totalPlatformFee
        totalFee
        startTime
        endTime
      }
      hospitalObj {
        name
        city
        district
      }

      careTaker {
        c_at
        name
        gender
        age
        phone
        matchedCareOrderList {
          isPrimary
          bundleStartTime
          bundleEndTime
        }
      }

      makeOfferList {
        _id
        state
        dailyServiceFee
        hourlyServiceFee
        revealedTime
        expectedConcealTime
        isLiked
        careTaker {
          c_at
          name
          gender
          age
          adminQuote
          avatarPhotoUrl
          aboutMeText
          feedbackSummary {
            remarkList {
              titleZh
              count
            }
            commentList {
              comment
              commentedTime
              hospital {
                name
                city
                district
              }
            }
            avgScore
            successCareOrderCount
          }
        }
        timeSlotList {
          _id
          state
          platformFeePercentage
          dailyFee
          expectedTotalFee
          expectedStartTime
          expectedEndTime
          expectedServiceHours
          expectedServiceDays
        }
      }
    }
  }
`;
const CareOrderFeedBackListQuery = graphql `
  query graphqlClientCareOrderForFeedbackQuery($_id: String!, $careOrderIdList: [String]) {
    clientCareOrderList(_id: $_id, careOrderIdList: $careOrderIdList) {
      _id
      feedback {
        isScored
      }
    }
  }
`;
const CareOrderHistoryListQuery = graphql `
  query graphqlClientCareOrderHistoryListQuery($_id: String!) {
    clientCareOrderList(_id: $_id) {
      _id
      c_at

      gender
      height
      weight
      age

      requiredGender

      symptom
      hospitalBed
      tube
      servedItem
      lang
      notes

      hospitalObj {
        name
        city
        district
      }

      contactName
      contactGender
      contactPhone
      contactEmail
    }
  }
`;
const UnpaidCareOrderListQuery = graphql `
  query graphqlClientUnpaidCareOrderListQuery($_id: String!, $careOrderIdList: [String]) {
    clientCareOrderList(_id: $_id, careOrderIdList: $careOrderIdList) {
      _id
      certificateId

      paymentList {
        _id
        totalFee
        cancellationFee
        paid
      }
    }
  }
`;
const AliveCareOrderListQuery = graphql `
  query graphqlClientAliveCareOrderListQuery($_id: String!, $stateList: [Int]) {
    clientCareOrderList(_id: $_id, stateList: $stateList) {
      _id
      c_at
      initialType
      state
      certificateId
      isDefaultAsap

      gender
      age
      height
      weight

      hospitalBed
      servedItem
      symptom
      tube
      requiredGender
      lang
      notes

      contactName
      contactGender
      contactPhone
      contactEmail

      totalPaidFee
      doPayOffPayment
      hourlyServiceFee

      defaultTimeSlotList {
        _id
        state
        platformFeePercentage
        dailyFee
        expectedTotalFee
        expectedStartTime
        expectedEndTime
        expectedServiceHours
        expectedServiceDays
      }

      timeSlotList {
        _id
        state
        platformFeePercentage
        dailyFee
        expectedTotalFee
        expectedStartTime
        expectedEndTime
        expectedServiceHours
        expectedServiceDays
        totalFee
        startTime
        endTime
      }

      hospitalObj {
        name
        city
        district
      }

      careTaker {
        c_at
        name
        gender
        age
        phone
        matchedCareOrderList {
          isPrimary
          bundleStartTime
          bundleEndTime
        }
      }

      makeOfferList {
        _id
        state
        dailyServiceFee
        hourlyServiceFee
        revealedTime
        expectedConcealTime
        isLiked
        careTaker {
          c_at
          name
          gender
          age
          adminQuote
          avatarPhotoUrl
          aboutMeText
          feedbackSummary {
            remarkList {
              titleZh
              count
            }
            commentList {
              comment
              commentedTime
              hospital {
                name
                city
                district
              }
            }
            avgScore
            successCareOrderCount
          }
        }
        timeSlotList {
          _id
          state
          platformFeePercentage
          dailyFee
          expectedTotalFee
          expectedStartTime
          expectedEndTime
          expectedServiceHours
          expectedServiceDays
        }
      }
    }
  }
`;
export default {
    // #TODO
    // purge fetchCareOrderList
    fetchCareOrderList: (variables, context) => fetchQueryWrapper(CareOrderListQuery, variables, context),
    fetchCareOrderForFeedback: (variables, context) => fetchQueryWrapper(CareOrderFeedBackListQuery, variables, context),
    fetchCareOrderHistoryList: (variables, context) => fetchQueryWrapper(CareOrderHistoryListQuery, variables, context),
    fetchUnpaidCareOrderList: (variables, context) => fetchQueryWrapper(UnpaidCareOrderListQuery, variables, context),
    fetchAliveCareOrderList: (variables, context) => fetchQueryWrapper(AliveCareOrderListQuery, variables, context),
};
